export default {
    inputContainer: [
            '<span class="uwr-input-container uwr-input-{{state}}">',
                '<span class="uwr-input-before"></span>',
                '<span class="uwr-input-content">',
                    '<span class="uwr-input-label uwr-input-label-top"></span>',
                    '<span class="uwr-input-placeholder uwr-input-label-bottom"></span>',
                '</span>',
                '{{#messageIcon}}',
                    '<span class="uwr-input-message uwr-input-no-message" tabindex="-1"></span>',
                '{{/messageIcon}}',
                '<span class="uwr-input-after"></span>',
            '</span>'
         ].join(''),

     inputMessageIcon:
         '<span class="uwr-input-message uwr-input-no-message" tabindex="-1"></span>',

     inputMessageBox:
         '<div class="uwr-message-box uwr-message-box-hidden uwr-arrow-top-right" data-icon-type="none"></div>'
};



//////////////////
// WEBPACK FOOTER
// ./widgets/Input/js/inputView.js
// module id = 20
// module chunks = main